// packages/components/src/offers/ProcessTimeline.tsx

import React from 'react';
import { motion } from 'framer-motion';
import clsx from 'clsx';
import { renderIcon } from '@dopomogai/utils';
import { IconName } from '@dopomogai/ui';

// The ProcessStep interface now expects a final `title` string.
interface ProcessStep {
  id: string; // Add an id for a stable key
  icon: IconName;
  title: string;
}

interface ProcessTimelineProps {
  steps: ProcessStep[];
}

export const ProcessTimeline: React.FC<ProcessTimelineProps> = ({ steps }) => {
  return (
    <div className="relative max-w-2xl mx-auto">
      {/* The vertical line */}
      <div className="absolute left-6 top-0 h-full w-0.5 bg-slate-300 -translate-x-1/2" />
      
      <div className="space-y-16">
        {steps.map((step, index) => (
            <motion.div 
              key={step.id}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.5 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="relative flex items-center gap-8"
            >
              {/* Step Circle */}
              <div className="z-10 flex items-center justify-center w-12 h-12 rounded-full border-2 border-black bg-emerald-500 text-white font-bold text-lg flex-shrink-0">
                {index + 1}
              </div>

              {/* Content Card */}
              <div className="flex items-center gap-4 bg-white p-4 rounded-lg border-2 border-black shadow-[4px_4px_0px_#000]">
                  <div className="p-2 bg-slate-100 border-2 border-black rounded-lg">
                    {renderIcon(step.icon)}
                  </div>
                  <h4 className="font-bold text-lg text-gray-900">{step.title}</h4>
              </div>
            </motion.div>
          )
        )}
      </div>
    </div>
  );
};